import Axios, {AxiosInstance, AxiosPromise} from 'axios';
import ApiService from './apiService';
import EcMemberSearch from '../../../types/ec/ecMemberSearch';

export const MemberSearchServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.apimUrl + 'enterprise-coach/member-search',
	headers: {
		'Ocp-Apim-Subscription-Key': window.lt.api.apimKey,
	},
});

export default class MemberSearchService extends ApiService implements EcMemberSearch.IMemberSearchService {
	constructor() {
		super('member-search-service', MemberSearchServiceAxiosInstance);
	}

	public searchMembers(data: EcMemberSearch.ISearchRequestObject): AxiosPromise<EcMemberSearch.ISearchMemberResponse> {
		const searchObject: EcMemberSearch.ISearchRequestObject = {
			term: data.term,
			clubIds: data.clubIds,
		};

		return this.axiosInstance.post('/member', searchObject, {cancelToken: data.token});
	}

	public searchMemberPhotos(data: EcMemberSearch.ISearchMemberPhotoRequestObject, ignoreLoading: boolean): AxiosPromise<EcMemberSearch.ISearchMemberPhotoResponse> {
		const memberData: object = {
			memberIds: data.memberIds,
		};
		const config: object = {
			ignoreLoading,
			suppressError: true,
			cancelToken: data.token,
		};

		return this.axiosInstance.post('/member/photos', memberData, config);
	}
}

export const memberSearchService = new MemberSearchService();
